import { t } from "i18next";

import { isValidPositiveNumber, yupLocalized } from "@ryde/shared";

const directions = ["A", "B", "AB"];

const hubNotSameAsStationsTest = (
  hubId: number | null | undefined,
  originStationId: number | null | undefined,
  destinationStationId: number | null | undefined,
): boolean => {
  if (!isValidPositiveNumber(hubId)) {
    return true;
  }
  return hubId !== originStationId && hubId !== destinationStationId;
};

export const bulkCreateBookingsValidationSchema = {
  direction: yupLocalized.string().oneOf(directions).required(),
  arrivalTime: yupLocalized.string().when("direction", (direction, schema) => {
    if (direction.includes("A") || direction.includes("AB")) {
      return schema.required();
    }

    return schema;
  }),
  departureTime: yupLocalized
    .string()
    .when("direction", (direction, schema) => {
      if (direction.includes("B") || direction.includes("AB")) {
        return schema.required();
      }

      return schema;
    }),
  hubStationA: yupLocalized
    .number()
    .nullable()
    .test(
      "hub-a-not-same-as-stations",
      t("hub.hubSameAsBookingStation"),
      function (hubStationA) {
        return hubNotSameAsStationsTest(
          hubStationA,
          this.parent?.originStationIdA,
          this.parent?.destinationStationIdA,
        );
      },
    ),
  hubStationB: yupLocalized
    .number()
    .nullable()
    .test(
      "hub-b-not-same-as-stations",
      t("hub.hubSameAsBookingStation"),
      function (hubStationB) {
        return hubNotSameAsStationsTest(
          hubStationB,
          this.parent?.originStationIdB,
          this.parent?.destinationStationIdB,
        );
      },
    ),
};
